module.exports = __webpack_public_path__ + "static/img/banner.29ad85b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/configure/tlsp/banner.jpg
// module id = uMir
// module chunks = 23